'use client'

import Box from '@mui/material/Box'
import { linkClasses } from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'

export const FooterBackground = styled(Box)(({ theme }) => ({
  backgroundColor: '#003564',
  color: theme.palette.grey[400],

  [`& .${linkClasses.root}`]: {
    color: 'inherit',
  },
}))

export const FooterRow = styled(Stack)(({ theme }) => ({
  ...theme.typography.caption,
  flexDirection: 'column',
  alignItems: 'center',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}))
